import React from 'react';

export interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  children,
  actions,
  className = '',
}) => {
  return (
    <div className={`relative flex flex-col min-w-0 break-words dashboard-card rounded-2xl bg-clip-border ${className}`}>
      <div className="p-4 pb-0 mb-0 bg-transparent border-b-0 rounded-t-2xl">
        <div className="flex flex-wrap -mx-3">
          <div className="flex-none w-auto max-w-full px-3">
            <h6 className="mb-0 font-semibold leading-normal text-lg text-slate-700">{title}</h6>
          </div>
          {actions && (
            <div className="flex-none w-auto max-w-full px-3 ml-auto">
              {actions}
            </div>
          )}
        </div>
      </div>
      <div className="flex-auto p-4 pt-0">
        {children}
      </div>
    </div>
  );
};

export default ChartCard;
